export default __webpack_public_path__ + "81cfbea4977dd15af6d13c5e89d3c03d.jpeg";